import CreateGame from "./CreateGame";
import JoinGame from "./JoinGame";
import useTranslation from "next-translate/useTranslation";
import { useEffect } from "react";
import {
  chooseGame,
  enterLobby,
  exitLobby,
  useLobby,
  setTab,
} from "../../ducks/lobby";
import { useRouter } from "next/router";
import {
  VARIANT_CHESS,
  CREATE_GAME_TAB,
  JOIN_GAME_TAB,
} from "@chesshotel/constants";
import { getModeId } from "../../util/util";

export default function LobbyBody() {
  const { t } = useTranslation("common");

  const { invites, tab } = useLobby();

  const numInvites = invites ? invites.length : 0;

  const router = useRouter();

  useEffect(() => {
    router.prefetch("/iframe/game");
    enterLobby();

    chooseGame({
      time: 5,
      inc: 2,
      variant: VARIANT_CHESS,
      modeId: getModeId(5, 2),
    });

    return () => {
      exitLobby();
    };
  }, []);

  return (
    <div className="flex items-center justify-center w-full px-2 mb-3">
      <div className="flex flex-col items-center w-full md:w-2/3 lg:w-1/2">
        <div className="flex w-full rounded-t-xl text-white bg-altblue-300">
          <div
            onClick={() => setTab(CREATE_GAME_TAB)}
            className={`flex items-center w-1/2 pt-3 pb-2.5 pl-4 text-sm md:text-base
            font-semibold rounded-t-xl select-none border-b-2 border-altblue-600
              ${
                tab !== JOIN_GAME_TAB
                  ? "bg-altblue-600"
                  : "hover:opacity-60 cursor-pointer"
              }`}
          >
            {t("Create game")}
          </div>
          <div
            onClick={() => setTab(JOIN_GAME_TAB)}
            className={`flex items-center w-1/2 pt-3 pb-2 pl-4 text-sm md:text-base
            font-semibold rounded-t-xl select-none border-b-2 border-altblue-600
              ${
                tab === JOIN_GAME_TAB
                  ? "bg-altblue-600"
                  : "hover:opacity-60 cursor-pointer"
              }`}
          >
            <div className="relative">
              {t("Join game")}
              {numInvites > 0 && tab === CREATE_GAME_TAB && (
                <div
                  className="bg-altblue-500 absolute right-0 top-0 flex items-center justify-center rounded-lg 
    text-white w-6 h-6 transform translate-x-7 -translate-y-1"
                >
                  {numInvites}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex w-full border border-altgray-100 border-t-0 rounded-b-md">
          {tab === CREATE_GAME_TAB ? <CreateGame /> : <JoinGame />}
        </div>
      </div>
    </div>
  );
}
